import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    rightBox: (color: string) => ({
      backgroundColor: color,
      width: '20px',
      borderBottomRightRadius: '4px',
      borderTopRightRadius: '4px'
    }),
    bold: {
      fontWeight: "bold"
    },
    sizeText: {
      fontSize: '14px'
    },
    gridContainer: {
      padding: 2,
      display: 'flex',
      alignItems: 'center'
    },
    flex: {
      display: 'flex'
    }
  }
}
